var _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#716BF1",
    fillRule: "evenodd",
    d: "M17 2h2v3h3v2h-3v3h-2V7h-3V5h3V2zM2 15a2 2 0 012-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2v-5z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 2,
    y: 2,
    fill: "#716BF1",
    opacity: 0.6,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 13,
    y: 13,
    fill: "#716BF1",
    opacity: 0.6,
    rx: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZmlsbD0iIzcxNkJGMSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTcgMmgydjNoM3YyaC0zdjNoLTJWN2gtM1Y1aDNWMnpNMiAxNWEyIDIgMCAwMTItMmg1YTIgMiAwIDAxMiAydjVhMiAyIDAgMDEtMiAySDRhMiAyIDAgMDEtMi0ydi01eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+CiAgPHJlY3Qgd2lkdGg9IjkiIGhlaWdodD0iOSIgeD0iMiIgeT0iMiIgZmlsbD0iIzcxNkJGMSIgb3BhY2l0eT0iLjYiIHJ4PSIyIi8+CiAgPHJlY3Qgd2lkdGg9IjkiIGhlaWdodD0iOSIgeD0iMTMiIHk9IjEzIiBmaWxsPSIjNzE2QkYxIiBvcGFjaXR5PSIuNiIgcng9IjIiLz4KPC9zdmc+Cg==";
export { SvgComponents as ReactComponent };